import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router';
import { AuxiliaryEsimOrderScene } from '../../../components/AuxiliaryEsimOrderScene/AuxiliaryEsimOrderScene.js';
import { AuxiliaryEsimOrderPhaseEnum } from '../../../components/AuxiliaryEsimOrderScene/auxiliaryEsimOrderEnums.js';
import { setAuxiliaryEsimOrderPhase } from '../../../selfservice/actions/index.js';
import { setMultisimSubscriptionToken } from '../../../selfservice/common/localStorageUtils';
import { initiateElisaIdV2Login } from '../../common/util/elisaIdLogin';

export const AuxiliaryEsimOrderPath = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname.endsWith('/manage')) {
      dispatch(setAuxiliaryEsimOrderPhase(AuxiliaryEsimOrderPhaseEnum.MANAGE));
    }
  }, [dispatch, location]);
  const startElisaIdV2Login = (locale: string) => {
    const subscriptionToken = new URLSearchParams(location.search).get('subscriptionToken') ?? undefined;
    setMultisimSubscriptionToken(subscriptionToken);
    void initiateElisaIdV2Login(locale);
  };

  return (
    <div id="auxiliary-esim-order">
      <AuxiliaryEsimOrderScene startElisaIdV2Login={startElisaIdV2Login} />
    </div>
  );
};
